import React, { useState, useEffect } from 'react';
import './DeckSize.css';
import {clearScene} from '../../DeckScene/ThreeFunctionsJS/sceneInitialization.js'

const DeckSize = ({ cargoArea, setCargoArea, isCreated, setIsCreated, cargos, setCargos, onMessage }) => {
  const [cargoAreaData, setCargoAreaData] = useState({ });
  
  useEffect(() => {
    if (cargoArea && cargoArea.length > 0 ) {
      // When cargoArea exists in parent but our local state is empty
      // Sync the local state from parent
      const area = cargoArea[0];
      setCargoAreaData({
        uuid: area.uuid,
        deckType: area.deckType,
        widthX: area.widthX ,
        heightY: area.heightY,
        depthZ: area.depthZ,
        x: 0,
        y: 0,
        z: 0
      });
      setIsCreated(true);
    }
  }, [cargoArea, isCreated]);

  const [cargoAreaTypes, setCargoAreaTypes] = useState([
    { uuid: '1', deckType: 'Standard 20ft', widthX: 2400, heightY: 2400, depthZ: 6000 },
    { uuid: '2', deckType: 'Standard 40ft', widthX: 2400, heightY: 2400, depthZ: 12000 },
    { uuid: '3', deckType: 'High Cube', widthX: 2400, heightY: 2700, depthZ: 12000 },
    { uuid: '4', deckType: 'Flat Rack', widthX: 2400, heightY: 0, depthZ: 12000 },
    { uuid: '5', deckType: 'Open Top', widthX: 2400, heightY: 2400, depthZ: 12000 },
    { uuid: '6', deckType: 'Refrigerated', widthX: 2300, heightY: 2300, depthZ: 12000 },
    { uuid: '7', deckType: 'Custom', widthX: 0, heightY: 0, depthZ: 0 }
  ]);

  // Cargo Area Functions
  const handleDeckTypeChange = (deckType) => {
    // Only allow changes if not created
    if (!isCreated) {
      const selectedType = cargoAreaTypes.find(type => type.deckType === deckType);
      if (selectedType) {
        setCargoAreaData({
          uuid: selectedType.uuid,
          deckType: selectedType.deckType,
          widthX: selectedType.widthX,
          heightY: selectedType.heightY,
          depthZ: selectedType.depthZ,
          x: 0,
          y: 0,
          z: 0
        });
      }
    }
  };

  const handleCustomDimensionChange = (field, value) => {
    // Only allow changes if not created
    if (!isCreated && cargoAreaData.deckType === 'Custom') {
      setCargoAreaData(prev => ({
        ...prev,
        [field]: Math.max(0, value)
      }));
    }
  };

  const handleCreateCargoArea = () => {
    if (!cargoAreaData.deckType ) {
      onMessage('Please select a deck type', 'error');
      // alert('Please select a deck type');
      return;
    }


    // Validate custom dimensions
    if (cargoAreaData.deckType === 'Custom') {
      if (cargoAreaData.widthX <= 0 || cargoAreaData.heightY <= 0 || cargoAreaData.depthZ <= 0) {
        onMessage('Please enter valid dimensions for custom cargo area');
        return;
      }
    }

    // Create cargo area object
    const newCargoArea = [{
      uuid: cargoAreaData.uuid,
      deckType: cargoAreaData.deckType,
      widthX: cargoAreaData.widthX,
      heightY: cargoAreaData.heightY,
      depthZ: cargoAreaData.depthZ,
      x: 0,
      y: 0,
      z: 0
    }];

    setCargoArea(newCargoArea);
    
    // Set created state to true to disable editing
    setIsCreated(true);
  };

  const handleResetCargoArea = () => {
    // Reset the created state to allow editing again
    setIsCreated(false);
    
    const newCargos = cargos.map(cargo => ({
      uuid: cargo.uuid,
      trackNumber: cargo.trackNumber,
      widthX: cargo.widthX,
      heightY: cargo.heightY,
      depthZ: cargo.depthZ,
      x: cargo.x,
      y: cargo.y,
      z: cargo.z,
      vehicle: cargo.vehicle,
      bol: cargo.bol,
      layer: cargo.layer,
      active: false,
      visible: true // default to true if not specified
    }));

    setCargoArea();
    setCargos(newCargos);
    
    // Also reset the form data
    setCargoAreaData({
      deckType: '',
      widthX: 0,
      heightY: 0,
      depthZ: 0,
      x: 0,
      y: 0,
      z: 0
    });
  };

  return (
    <div className="deck-size-container">
      {/* Right Side - Cargo Area */}
      {/* <div className="content-sidebar"> */}
        <div className="cargo-area-section">
          <div className="cargo-area-header">
            <h3>Deck</h3>
            <div className="cargo-area-controls">
              <button 
                onClick={handleCreateCargoArea}
                className="btn btn-modern btn-primary"
                disabled={isCreated} // Disable button after creation
              >
                {isCreated ? 'Created' : 'Create'}
              </button>
              <button 
                onClick={handleResetCargoArea}
                className="btn btn-modern btn-secondary"
                disabled={!isCreated}
              >
                {!isCreated ? 'Reset' : 'Reset'}
              </button>
            </div>
          </div>

          {/* Always show dimensions in readable format */}
          <div className="deck-dimensions-modern">
            <div className="deck-grid-modern">
              <div className="dimension-row-modern">
                <span className="dimension-label-modern">Deck Type</span>
                <select
                  id="deckType"
                  name="deckType"
                  value={cargoAreaData.deckType}
                  onChange={(e) => handleDeckTypeChange(e.target.value)}
                  className="form-select-modern"
                  disabled={isCreated} // Disable when created
                >
                  
                  <option value="select-field">Select Deck Type</option>
                  {cargoAreaTypes.map(type => (
                    <option key={type.uuid} value={type.deckType}>
                      {type.deckType}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="dimension-row-modern">
                <span className="dimension-label-modern">width</span>
                {cargoAreaData.deckType === 'Custom' ? (
                  <div className="dimension-input-group-modern">
                    <input
                      id="customwidth"
                      name="customwidth"
                      type="number"
                      value={cargoAreaData.widthX}
                      onChange={(e) => handleCustomDimensionChange('widthX', parseInt(e.target.value) || 0)}
                      className="dimension-input-modern"
                      min="0"
                      placeholder="0"
                      disabled={isCreated} // Disable when created
                    />
                    <span className="dimension-unit">mm</span>
                  </div>
                ) : (
                  <span className="dimension-value-modern">
                    {cargoAreaData.widthX > 0 ? `${cargoAreaData.widthX.toLocaleString()} mm` : 'N/A'}
                  </span>
                )}
              </div>
              
              <div className="dimension-row-modern">
                <span className="dimension-label-modern">height</span>
                {cargoAreaData.deckType === 'Custom' ? (
                  <div className="dimension-input-group-modern">
                    <input
                      id="customheight"
                      name="customheight"
                      type="number"
                      value={cargoAreaData.heightY}
                      onChange={(e) => handleCustomDimensionChange('heightY', parseInt(e.target.value) || 0)}
                      className="dimension-input-modern"
                      min="0"
                      placeholder="0"
                      disabled={isCreated} // Disable when created
                    />
                    <span className="dimension-unit">mm</span>
                  </div>
                ) : (
                  <span className="dimension-value-modern">
                    {cargoAreaData.heightY > 0 ? `${cargoAreaData.heightY.toLocaleString()} mm` : 'N/A'}
                  </span>
                )}
              </div>
              
              <div className="dimension-row-modern">
                <span className="dimension-label-modern">depth</span>
                {cargoAreaData.deckType === 'Custom' ? (
                  <div className="dimension-input-group-modern">
                    <input
                      id="customdepth"
                      name="customdepth"
                      type="number"
                      value={cargoAreaData.depthZ}
                      onChange={(e) => handleCustomDimensionChange('depthZ', parseInt(e.target.value) || 0)}
                      className="dimension-input-modern"
                      min="0"
                      placeholder="0"
                      disabled={isCreated} // Disable when created
                    />
                    <span className="dimension-unit">mm</span>
                  </div>
                ) : (
                  <span className="dimension-value-modern">
                    {cargoAreaData.depthZ > 0 ? `${cargoAreaData.depthZ.toLocaleString()} mm` : 'N/A'}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Volume Preview */}
          {cargoAreaData.deckType && cargoAreaData.widthX > 0 && cargoAreaData.heightY > 0 && cargoAreaData.depthZ > 0 && (
            <div className="volume-preview-modern">
              <div className="volume-info">
                <span className="volume-label">Estimated Volume</span>
                <span className="volume-value">
                  {((cargoAreaData.widthX * cargoAreaData.heightY * cargoAreaData.depthZ) / 1_000_000_000).toFixed(2)} m³
                </span>
              </div>
            </div>
          )}
        </div>
      {/* </div> */}
    </div>
  );
};

export default DeckSize;